import srraf from "srraf";

import { emit } from "@/glow/events";

const breakpoints = [480, 720, 960, 1024, 1200, 1400];

const widthWatcher = () => {
  const reversedBreakpoints = breakpoints.reverse();

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth;

  let lastSize = viewportWidth;

  srraf(({ vw }) => {
    emit("window:resized");

    if (vw > lastSize) {
      breakpoints.forEach(width => {
        if (lastSize < width && vw >= width) {
          emit(`window:above-${width}`);
        }
      });
    } else {
      reversedBreakpoints.reverse().forEach(width => {
        if (lastSize > width && vw < width) {
          emit(`window:below-${width}`);
        }
      });
    }

    if (vw !== lastSize) emit("window:width-changed");

    lastSize = vw;
  });
};

export default widthWatcher;
